import { forwardRef } from 'react';
import type { ButtonHTMLAttributes } from 'react';
import { kaiFontFamily } from '../../../../core/tokens';
import {
  REVIEW_COLORS,
  REVIEW_CONTROL_SIZES,
  REVIEW_RADII,
} from '../reviewFlowTokens';
import {
  resolveStyleOverride,
  type StyleOverride,
} from '../styleOverrides';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  styleOverride?: StyleOverride;
}

export const IconButton = forwardRef<
  HTMLButtonElement,
  IconButtonProps
>(({ styleOverride: buttonCss, style, type = 'button', ...props }, ref) => {
  return (
    <button
      ref={ref}
      type={type}
      style={{
        width: REVIEW_CONTROL_SIZES.iconButton,
        height: REVIEW_CONTROL_SIZES.iconButton,
        minWidth: REVIEW_CONTROL_SIZES.iconButton,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: `1px solid ${REVIEW_COLORS.border}`,
        borderRadius: REVIEW_RADII.medium,
        background: 'transparent',
        color: REVIEW_COLORS.textMuted,
        cursor: 'pointer',
        appearance: 'none',
        fontFamily: kaiFontFamily,
        ...style,
        ...resolveStyleOverride(buttonCss),
      }}
      {...props}
    />
  );
});

IconButton.displayName = 'IconButton';
